import { atom } from "jotai";
import UserCollectionRecord from "models/view-models/user-collection-record";

const UserCollectionAtom = atom<UserCollectionRecord[]>([]);

export default UserCollectionAtom;
